try {
  
  let cmSizeChartButton = document.querySelector('.cm.measurement-button');
  let inchSizeChartButton = document.querySelector('.in.measurement-button');
  
  
  
      function measurementHandle(val) {
          console.log('measurementHandle', val);
          const tableClass = '.' + val + '-size-guide-table';
          const guideTablesDisplay = document.querySelectorAll(tableClass);
          const guideTablesHide = document.querySelectorAll('.size-guide-table');
  
          guideTablesHide.forEach(table=>{
              table.style.display = 'none';
          })
  
          guideTablesDisplay.forEach(table=>{
              table.style.display = 'table';
          })
       
  
          const buttonClass = '.' + val + '.measurement-button';
          const guideButton = document.querySelectorAll(buttonClass);
          const guideButtons = document.querySelectorAll('.measurement-button');
   
          guideButtons.forEach(button=>{
              button.style.textDecoration= 'none';
          })
  
          guideButton.forEach(button=>{
              button.style.textDecoration= 'underline';
          })
     }
  
      function measurementHandleInner(val) {
          console.log('measurementHandleInner', val);
          const tableClass = 'tool-tip div.tool-tip__inner div.tool-tip__content div.size-guide-tab .' + val + '-size-guide-table';
          const guideTablesDisplay = document.querySelectorAll(tableClass);
          const guideTablesHide = document.querySelectorAll('.size-guide-table');
  
          guideTablesHide.forEach(table=>{
              table.style.display = 'none';
          })
  
          guideTablesDisplay.forEach(table=>{
              table.style.display = 'table';
          })
       
  
          const buttonClass = '.' + val + '.measurement-button';
          const guideButton = document.querySelectorAll(buttonClass);
          const guideButtons = document.querySelectorAll('.measurement-button');
   
          guideButtons.forEach(button=>{
              button.style.textDecoration= 'none';
          })
  
          guideButton.forEach(button=>{
              button.style.textDecoration= 'underline';
          })
     }
  
  cmSizeChartButton?.addEventListener('click',() => { measurementHandle('cm'); });
  inchSizeChartButton?.addEventListener('click',() => { measurementHandle('in'); });
  
  
  const modalTrigger = document.querySelector('tool-tip-trigger[data-tool-tip="size-chart"]');
  
  modalTrigger.addEventListener('click',() => {
    console.log('tool-tip-trigger');
    setTimeout(() => {
      let cmSizeChartButtonI = document.querySelector('tool-tip div.tool-tip__inner div.tool-tip__content div.size-guide-tab-container.size-guide div.measurements-container button.cm.measurement-button');
      let inchSizeChartButtonI = document.querySelector('tool-tip div.tool-tip__inner div.tool-tip__content div.size-guide-tab-container.size-guide div.measurements-container button.in.measurement-button');
      cmSizeChartButtonI.addEventListener('click',() => { measurementHandleInner('cm'); });
      inchSizeChartButtonI.addEventListener('click',() => { measurementHandleInner('in'); });
    }, 1000);
  });

} catch (error) {
  console.error(error);
}


const button = document.querySelector('.btn-scroll-to-top');

const displayButton = () => {
  if(button) {
    window.addEventListener('scroll', () => {  
      if (window.scrollY > 100) {
        button.style.display = "block";
      } else {
        button.style.display = "none";
      }
    });
  }
};

const scrollToTop = () => {
  if(button) {
    button.addEventListener("click", () => {
      window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth'
      }); 
    });
  }
};

document.addEventListener('DOMContentLoaded', () => {
  displayButton();
  scrollToTop();
  console.log('loaded')
});
